/* @refresh reload */
import { render } from 'solid-js/web'
import './styles/tokens.css'
import './styles/components.css'
import './styles/layout.css'
import App from './App.tsx'
import { AuthProvider } from './auth.tsx'

const root = document.getElementById('root')

render(
  () => (
    <AuthProvider>
      <App />
    </AuthProvider>
  ),
  root!,
)
